window.DS24 = window.DS24 || {};

DS24.quickAddBulk = (() => {

    class DS24QuickAddBulk {

        constructor(element) {

            this.element = element;

            this.input = element.querySelector(
                '.quantity__input'
            );

            this.plusButton = element.querySelector(
                'button[name="plus"]'
            );

            this.minusButton = element.querySelector(
                'button[name="minus"]'
            );

            this.variantId =
                this.input?.dataset.quantityVariantId;

            this.bind();

            this.update(
                Number(
                    this.input?.value || 0
                )
            );
        }

        bind() {

            this.plusButton?.addEventListener(
                'click',
                (e) => {

                    e.preventDefault();
                    e.stopImmediatePropagation();

                    this.increment();
                },
                true
            );

            this.minusButton?.addEventListener(
                'click',
                (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    const qty =
                        Number(
                            this.input?.value || 0
                        );

                    if (qty <= 0) {
                        return;
                    }
                    this.decrement();
                },
                true
            );

            this.input?.addEventListener(
                'change',
                (e) => {

                    e.preventDefault();

                    this.setQuantity(
                        parseInt(
                            e.target.value || 0,
                            10
                        )
                    );
                }
            );
        }

        showProgress() {

            const progress =
                this.element.querySelector(
                    '.progress-bar-container'
                );

            progress?.classList.remove(
                'hidden'
            );
        }

        hideProgress() {

            const progress =
                this.element.querySelector(
                    '.progress-bar-container'
                );

            progress?.classList.add(
                'hidden'
            );
        }

        async getDigistoreId() {

            if (this.digistoreId) {
                return this.digistoreId;
            }

            this.digistoreId =
                await DS24.helpers.resolveDigistoreId(
                    this.variantId
                );

            return this.digistoreId;
        }

        async getActiveCartContainer() {

            if (this.cartContainer) {
                return this.cartContainer;
            }

            let cart = document.querySelector(
                '.app_cart_tooltip_container'
            );

            if (cart) {

                this.cartContainer = cart;

                return cart;
            }

            const style = document.createElement('style');

            style.id = 'ds24-hidden-cart-style';

            style.innerHTML = `
                div.app_cart_tooltip_container {
                    visibility: hidden !important;
                    opacity: 0 !important;
                    pointer-events: none !important;
                }
            `;

            document.head.appendChild(style);

            ds24cart_show(document.body);

            return new Promise(resolve => {

                let attempts = 0;

                const timer = setInterval(() => {

                    attempts++;

                    cart = document.querySelector(
                        '.app_cart_tooltip_container'
                    );

                    if (cart) {

                        clearInterval(timer);

                        this.cartContainer = cart;

                        setTimeout(() => {
                            cart.querySelector(
                                '.app_dialog_button_close'
                            )?.click();

                        }, 1000);

                        setTimeout(() => {

                           document
                            .getElementById(
                                'ds24-hidden-cart-style'
                            )
                            ?.remove();

                        }, 2000);

                        resolve(cart);

                        return;
                    }

                    if (attempts >= 30) {

                        clearInterval(timer);

                        resolve(null);
                    }

                }, 100);

            });
        }

       async getCartQuantity(productId) {

            const cart =
                await this.getActiveCartContainer();

            await new Promise(
                resolve => setTimeout(
                    resolve,
                    500
                )
            );

            const input =
                cart.querySelector(
                    `.app_cart_quantity_${productId}`
                );

            if (!input) {
                return 0;
            }

            return Number(
                input.value || 0
            );
        }

        async setCartQuantity(
            productId,
            quantity
        ) {

            const cart =
                await this.getActiveCartContainer();

            if (!cart) {
                return false;
            }

            const input =
                document.querySelector(
                    `.app_cart_quantity_${productId}`
                );

            if (!input) {
                return false;
            }

            input.value = quantity;

            input.dispatchEvent(
                new Event('input', {
                    bubbles: true
                })
            );

            input.dispatchEvent(
                new Event('change', {
                    bubbles: true
                })
            );
          
        }

        async increment() {

            const digistoreId =
                await this.getDigistoreId();

            if (!digistoreId) {
                return;
            }

            this.showProgress();

            const cartQty =
                await this.getCartQuantity(
                    digistoreId
                );

            if (cartQty === 0) {

                ds24cart_add(
                    digistoreId,
                    1
                );
                return;
            }

            this.setCartQuantity(
                digistoreId,
                cartQty + 1
            );
        }

        async decrement() {

            const digistoreId =
                await this.getDigistoreId();
           
            if (!digistoreId) {
                return;
            }

            const cartQty =
                await this.getCartQuantity(
                    digistoreId
                );

            if (cartQty <= 0) {
                return;
            }

            this.showProgress();

            this.setCartQuantity(
                digistoreId,
                cartQty - 1
            );
        }

        async setQuantity(
            newQty
        ) {

            newQty = Math.max(
                0,
                Number(newQty)
            );

            const digistoreId =
                await this.getDigistoreId();

            if (!digistoreId) {
                return;
            }

            this.showProgress();

            const cartQty =
                await this.getCartQuantity(
                    digistoreId
                );

            if (cartQty === 0) {

                if (newQty > 0) {

                    ds24cart_add(
                        digistoreId,
                        newQty
                    );
                }

                return;
            }

            this.setCartQuantity(
                digistoreId,
                newQty
            );
        }

       update(quantity) {

            quantity = Math.max(
                0,
                Number(quantity)
            );

            if (this.input) {
                this.input.value = quantity;
            }

            if (!this.minusButton) {
                return;
            }

            if (quantity <= 0) {

                this.minusButton.classList.add(
                    'disabled'
                );

                this.minusButton.setAttribute(
                    'aria-disabled',
                    'true'
                );

            } else {

                this.minusButton.classList.remove(
                    'disabled'
                );

                this.minusButton.removeAttribute(
                    'disabled'
                );

                this.minusButton.setAttribute(
                    'aria-disabled',
                    'false'
                );
            }

            this.hideProgress();
        }
    }

    const instances =
        new Map();

    function init() {

        document
            .querySelectorAll(
                '.quick-add-bulk'
            )
            .forEach(element => {

                const input =
                    element.querySelector(
                        '.quantity__input'
                    );

                if (!input) {
                    return;
                }

                const variantId =
                    String(
                        input.dataset
                            .quantityVariantId
                    );

                if (
                    instances.has(
                        variantId
                    )
                ) {
                    return;
                }

                instances.set(
                    variantId,
                    new DS24QuickAddBulk(
                        element
                    )
                );
            });
    }

    async function syncCart(
        cart
    ) {

        for (
            const instance
            of instances.values()
        ) {

            const digistoreId =
                await instance.getDigistoreId();

            const item =
                cart.items.find(
                    item =>
                        String(
                            item.product_id
                        ) ===
                        String(
                            digistoreId
                        )
                );

            instance.update(
                item
                    ? Number(
                        item.quantity
                    )
                    : 0
            );
        }
    }

    function hideAllProgressBars() {

        document
            .querySelectorAll(
                '.progress-bar-container'
            )
            .forEach(bar => {

                bar.classList.add(
                    'hidden'
                );
            });
    }

    document.addEventListener(
        'DOMContentLoaded',
        init
    );

    document.addEventListener(
        'shopify:section:load',
        init
    );

    new MutationObserver(
        () => init()
    ).observe(
        document.body,
        {
            childList: true,
            subtree: true
        }
    );

    return {
        init,
        syncCart,
        hideAllProgressBars
    };

})();